import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, Slot } from "@builder.io/qwik";
import { selectItemContextId } from "./select-context.qwik.mjs";
const HSelectItemIndicator = component$((props) => {
  const selectContext = useContext(selectItemContextId);
  return /* @__PURE__ */ jsx("span", {
    "aria-hidden": "true",
    ...props,
    children: selectContext.isSelectedSig.value && /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HSelectItemIndicator
};
